<div class="layout-topbar">
    <div class="layout-topbar-content">
      <a href="#" id="menu-btn" class="menu-btn" >
        <i class="pi pi-bars"></i>
      </a>
      <img src="../assets/images/header/logorpnassist.png" class="topbar-logo">
  
      <a [routerLink]="['/documentation']" class="topbar-link" >Get Started</a>
    </div>
  </div>